{
  "enum": {
    "ExcIceJobV1JobStatus": {
      "CANCELED": "Canceled",
      "CREATING": "Creating",
      "DONE": "Done",
      "FAILED": "Failed",
      "PROCESSING": "Processing",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcIceJobV1TaskStatus": {
      "CREATED": "Created",
      "ERRORED": "Errored",
      "FAILED": "Failed",
      "PROCESSING": "Processing",
      "SUCCEEDED": "Succeeded",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "ExcIceJobV1JobQueryServiceJobListFilterableFields": {
      "data": {
        "spec": {
          "!type": "Data Spec Type"
        }
      },
      "jobId": "Job ID",
      "status": "Status"
    },
    "ExcIceJobV1TaskQueryServiceTaskListFilterableFields": {
      "jobId": "Job ID",
      "status": "Status",
      "taskId": "Task ID"
    }
  },
  "oneOf": {
    "ExcIceJobV1BatchToken": {
      "afterInstrument": "After Instrument",
      "fileOffset": "File Offset"
    },
    "ExcIceJobV1JobEventType": {
      "allCreated": "All Created",
      "allFinished": "All Finished",
      "batchDone": "Batch Done",
      "canceled": "Canceled",
      "created": "Created",
      "failed": "Failed",
      "metricsUpdated": "Metrics Updated"
    },
    "ExcIceJobV1JobResult": {
      "file": "File"
    },
    "ExcIceJobV1JobSpec": {
      "corpActionFile": "Corp Action File",
      "exportInstruments": "Export Instruments",
      "instrumentFile": "Instrument File",
      "reparseInstruments": "Reparse Instruments"
    },
    "ExcIceJobV1TaskEventType": {
      "created": "Created",
      "errored": "Errored",
      "failed": "Failed",
      "finished": "Finished",
      "processing": "Processing"
    },
    "ExcIceJobV1TaskSpec": {
      "corpAction": "Corp Action",
      "instrument": "Instrument"
    }
  },
  "sortEnum": {
    "ExcIceJobV1JobQueryServiceJobListSortableFields": {
      "metadata": {
        "createdAt": "Metadata Created At",
        "updatedAt": "Metadata Updated At"
      }
    },
    "ExcIceJobV1TaskQueryServiceTaskListSortableFields": {
      "metadata": {
        "createdAt": "Metadata Created At",
        "updatedAt": "Metadata Updated At"
      }
    }
  }
}